import React from 'react'
import './VoteRadioButton.scss'

export const VoteRadioButton = (props) => {
  return (
    <div className="vote-radio-button">
      
    </div>
  )
}

export default VoteRadioButton;